<template>
  <div class="moneyRecord">
    <div>
      <searchNav @change="change" />
    </div>
    <div class="feelist">
      <Datatable
        url="/Member/RZJFund/InvoiceList"
        :th="[$t('label.w163')+'/'+$t('label.w51'),$t('label.w159'),$t('label.w129'),$t('label.w164'),$t('label.w165'),$t('label.w166'),$t('label.w167')]"
        field="InvoiceList"
        v-slot="{item}"
        :filter="dataFilter"
        :tip="$t('msg.m131')"
      >
        <tr>
          <td>
            <div>{{item.CreatedAt}}</div>
            <!-- <div class="no">{{item.LoanSchemeNumber}}</div> -->
            <router-link
              class="no"
              :to="{name:'borrowDetails',params:{id:item.LoanSchemeId}}"
            >{{item.LoanSchemeNumber}}</router-link>
          </td>
          <td>{{item.TypeName}}</td>
          <td>{{item.PurposeName}}</td>
          <td>
            <span v-if="item.InOut==1">¥ {{item.Amount | money}}</span>
            <span v-else>— —</span>
          </td>
          <td>
            <span v-if="item.InOut==2">¥ {{item.Amount | money}}</span>
            <span v-else>— —</span>
          </td>
          <td>¥ {{item.AccountTotalAmount | money}}</td>
          <td>{{item.Description}}</td>
        </tr>
      </Datatable>
    </div>
  </div>
</template>

<script>
import searchNav from "./searchNav";
import Datatable from "@/components/datatable";
export default {
  components: { searchNav, Datatable },
  data() {
    return {
      dataFilter: {}
    };
  },
  methods: {
    change(v) {
      this.dataFilter = v;
      console.log(v);
      console.log(v.purpose);
    }
  }
};
</script>

<style lang="less" scoped>
.moneyRecord {
  .feelist {
    margin-top: 30px;
    td {
      .no {
        font-size: 12px;
        color: #7b7b7c;
      }
    }
  }
}
</style>

